export default {
    name: 'basic',
    state: {
        pageLoading: true,
        dateFormat: "DD-MM-YYYY",
        standarFormat: "YYYY-MM-DD",
        notification: false
    },
    getters: {
        getPageLoading: state => {
            return state.pageLoading
        },
        getDefaultDateFormat: state => {
            return state.dateFormat
        },
        getStandartFormatDate: state => {
            return state.standarFormat
        },
        getNotificationView: state => {
            return state.notification
        }
    },
    mutations: {
        PAGE_LOADING: (state, payload) => {
            state.pageLoading = payload
        },
        NOTIFICATION_VIEW: (state) => {
            state.notification = !state.notification
        }
    },
    actions: {
        SET_PAGE_LOADING(store, payload) {
            store.commit('PAGE_LOADING', payload)
        },
        SET_NOTIFICATION_VIEW(store) {
            store.commit('NOTIFICATION_VIEW')
        }
    }
}
